import axios from 'axios'
import {API_URL} from '../../constants'

const state = {
  loyaltyProgram: {
    name: '',
    max_count: null,
    valid_for_months: 6,
    status: 'new',
    card_name: '',
    purchase_count: 10,
    terms: '',
    auto_reissue: true,
    offer: {
      name: '',
      reward_expire_days: 30,
      terms: '',
    },
  },
  customers: [],
  foundCustomer: null,
  currentCustomerId: null,
  points: [],
  issuedPoint: 10,
  newPoints: {
    count: null,
  },
  removePointCount: null,
  rewards: [],
  customer: {},
  qr: null,
  newQr: null,
}

// actions
const actions = {
  async getLoyaltyData ({ commit }) {
    const response = await axios.get(`${API_URL}/api/v3/loyalty`)
    if (response.data.success) {
      const program = response.data.data.loyaltyProgram
      program.offer = response.data.data.offer
      program.offerImage = response.data.data.offerImage
      commit('setLoyaltyData', program)
    }
  },
  async saveLoyalty ({ commit, state, dispatch }, file = null) {
    try {
      const response = await axios.post(
        `${API_URL}/api/v3/loyalty`,
        state.loyaltyProgram,
      )
      const program = response.data.data
      commit('setLoyaltyData', program)
      console.log('file', file)
      if (file && !file.url) {
        const form = new FormData()
        form.append('position', '0')
        form.append('image', file)
        await axios.post(
          `${API_URL}/api/v3/business/${program.business_id}/offers/${program.offer.id}/images`,
          form,
        )
      }
    } catch (e) {
      throw e
    }
    dispatch('getLoyaltyData')
  },
  async newLoyaltyProgram ({ commit, state, dispatch }) {
    commit('newProgram')
    dispatch('getLoyaltyData')
  },
  async getCustomers ({ commit, state }) {
    state.foundCustomer = null
    const response = await axios.get(
      `${API_URL}/api/v3/customers`,
    )

    commit('setCustomersData', response.data.data)
  },
  async findCustomerByEmail ({ commit, state }) {
    const response = await axios.post(
      `${API_URL}/api/v3/customers`,
      {query: state.foundCustomer},
    )
    commit('setCustomersData', response.data.data)
  },
  async getPointsLog ({ commit, state }, userId) {
    const response = await axios.get(
      `${API_URL}/api/v3/customers/${userId}/points`,
    )
    commit('setPointsLog', response.data.data)
  },
  async givePoints ({ commit, state }, userId) {
    commit('newPoints')
    await axios.post(
      `${API_URL}/api/v3/customers/${userId}/points`,
      {
        userId: userId,
        countPoint: state.newPoints.count,
      },
    )
    const response = await axios.get(
      `${API_URL}/api/v3/customers/${userId}/points`,
    )
    commit('setPointsLog', response.data.data)
  },
  async removePoints ({ commit, state }, userId) {
    await axios.post(
      `${API_URL}/api/v3/customers/${userId}/points`,
      {
        userId: userId,
        countPoint: -state.removePointCount / 10,
      },
    )
    const response = await axios.get(
      `${API_URL}/api/v3/customers/${userId}/points`,
    )
    commit('setPointsLog', response.data.data)
  },
  async getRewardsLog ({ commit, state }, userId) {
    const response = await axios.get(
      `${API_URL}/api/v3/customers/${userId}/rewards`,
    )
    commit('setRewardsLog', response.data.data)
  },
  async validateReward ({ commit, state }, userId) {
    await axios.post(
      `${API_URL}/api/v3/customers/${userId.userId}/rewards`,
      {
        walletId: userId.walletId,
        userId: userId.userId,
      },
    )
    const response = await axios.get(
      `${API_URL}/api/v3/customers/${userId.userId}/rewards`,
    )
    commit('setRewardsLog', response.data.data)
  },
  async newQr ({ commit, state }) {
    commit('qrGenerating', true)

    const response = await axios.post(`${API_URL}/api/v3/qr`)
    commit('setQrCode', response.data.data)
    commit('qrGenerating', false)
  },
  async checkQr ({ commit, state }) {
    const response = await axios.get(
      `${API_URL}/api/v3/qr`,
    )
    commit('setQrCode', response.data.data)
  },
  async toggleStatus ({commit, state}) {
    const response = await axios.put(
      `${API_URL}/api/v3/loyalty/${state.loyaltyProgram.id}`,
      { status: state.loyaltyProgram.status === 'new' ? 'active' : 'new' }
    )

    commit('setLoyaltyData', {
      ...state.loyaltyProgram,
      status: response.data.data.loyaltyProgram.status,
    })
  }
}

// mutations
const mutations = {
  onLoyaltyDataChange (state, {field, value}) {
    state.loyaltyProgram[field] = value
  },
  onLoyaltyOfferChange (state, {field, value}) {
    state.loyaltyProgram.offer[field] = value
  },
  changeCustomerSearch (state, value) {
    state.foundCustomer = value
  },
  setLoyaltyData (state, data) {
    state.loyaltyProgram = data
  },
  setCustomersData (state, data) {
    state.customers = data
  },
  setPointsLog (state, data) {
    if (data.points) {
      state.customer = data.user
      state.points = data.points
    } else {
      state.points = data
    }
  },
  setRewardsLog (state, data) {
    state.rewards = data
  },
  onChangeIssuedPoint (state, data) {
    state.issuedPoint = data
  },
  onChangeRemovePoint (state, data) {
    state.removePointCount = data
  },
  setQrCode (state, data) {
    state.qr = data
  },
  setErrorMessage (state, message) {
    state.newQr = message
  },
  newProgram (state) {
    state.loyaltyProgram = {
      name: '',
      max_count: null,
      valid_for_months: 6,
      status: 'new',
      card_name: '',
      purchase_count: 10,
      terms: '',
      auto_reissue: true,
      offer: {
        name: '',
        reward_expire_days: 30,
        terms: '',
      },
    }
  },
  newPoints (state) {
    state.newPoints = {
      count: state.issuedPoint / 10,
    }
  },
  qrGenerating (state, generating) {
    state.qrGenerating = generating
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/loyalty.js